module.exports = __webpack_public_path__ + "static/media/axle_a.bb777530.svg";